import { LinkActionType, LinkStateType, } from '@kubit/web-ui-components/link/types';
import { TextDisplayType } from '@kubit/web-ui-components/text/types';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
import { LinkVariantType } from './variants';
const LINK_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    labelIconContainer: {
        display: TextDisplayType.INLINE_FLEX,
        align_items: 'center',
        color: 'inherit',
        gap: FOUNDATIONS.spacing_100,
        text_decoration: 'underline',
    },
    childrenContainer: {
        display: TextDisplayType.INLINE_FLEX,
        align_items: 'center',
        color: 'inherit',
        gap: FOUNDATIONS.spacing_100,
        text_decoration: 'underline',
    },
    container: {
        display: TextDisplayType.INLINE_FLEX,
        padding: FOUNDATIONS.spacing_50,
        // Used to border on focus
        border_radius: FOUNDATIONS.radius_100,
        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_weight_600,
        cursor: 'pointer',
        color: FOUNDATIONS.color_comp_navigation_link_primary_font,
    },
    icon: {
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_comp_navigation_link_primary_icon,
    },
});
const PRIMARY_CONTACT_CENTER_LINK_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
    container: {
        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
        color: FOUNDATIONS.color_contact_center_accent_default_primary_font_50,
    },
    icon: {
        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
        color: FOUNDATIONS.color_contact_center_accent_default_primary_icon_50,
    },
});
const SECONDARY_LINK_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
    container: {
        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
        color: FOUNDATIONS.color_comp_navigation_link_secondary_icon,
    },
    icon: {
        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
        color: FOUNDATIONS.color_comp_navigation_link_secondary_font,
    },
});
const MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
    container: {
        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
        color: FOUNDATIONS.color_exception_accent_default_secondary_font_50,
    },
    icon: {
        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
    },
});
const SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
    container: {
        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
        color: FOUNDATIONS.color_comp_navigation_link_techonly_font,
    },
    icon: {
        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
        color: FOUNDATIONS.color_comp_navigation_link_techonly_icon,
    },
});
export const getLinkStyles = (FOUNDATIONS, FONT) => {
    return {
        [LinkActionType.NAVIGATION]: {
            [LinkVariantType.PRIMARY]: {
                [LinkStateType.DEFAULT]: { ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT) },
                [LinkStateType.PRESSED]: {
                    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_primary_pressed_font,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_primary_pressed_icon,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
                    },
                    labelIconContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).labelIconContainer,
                        text_decoration: 'none',
                    },
                    childrenContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).childrenContainer,
                        text_decoration: 'none',
                    },
                },
            },
            [LinkVariantType.SECONDARY]: {
                [LinkStateType.DEFAULT]: { ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT) },
                [LinkStateType.PRESSED]: {
                    ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_secondary_pressed_font,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_secondary_pressed_icon,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_secondary_font,
                        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
                    },
                    icon: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_secondary_icon,
                    },
                    labelIconContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).labelIconContainer,
                        text_decoration: 'none',
                    },
                    childrenContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).childrenContainer,
                        text_decoration: 'none',
                    },
                },
            },
            [LinkVariantType.MAIN_SECTION_HEADERS]: {
                [LinkStateType.DEFAULT]: { ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT) },
                [LinkStateType.PRESSED]: {
                    ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_pressed_secondary_font_250,
                    },
                    icon: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_pressed_secondary_icon_250,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        font_variant: TextVariantType.FONT_PARAGRAPH_400,
                        color: FOUNDATIONS.color_exception_accent_default_secondary_font_50,
                    },
                    icon: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                    },
                    labelIconContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).labelIconContainer,
                        text_decoration: 'none',
                    },
                    childrenContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).childrenContainer,
                        text_decoration: 'none',
                    },
                },
            },
            [LinkVariantType.SECONDARY_ON_SURFACE]: {
                [LinkStateType.DEFAULT]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                },
                [LinkStateType.PRESSED]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_techonly_pressed_font,
                    },
                    icon: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_techonly_pressed_icon,
                    },
                    labelIconContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).labelIconContainer,
                        text_decoration: 'none',
                    },
                    childrenContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).childrenContainer,
                        text_decoration: 'none',
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_techonly_font,
                        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
                    },
                    icon: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_techonly_icon,
                    },
                    labelIconContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).labelIconContainer,
                        text_decoration: 'none',
                    },
                    childrenContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).childrenContainer,
                        text_decoration: 'none',
                    },
                },
            },
            [LinkVariantType.PRIMARY_CONTACT_CENTER]: {
                [LinkStateType.DEFAULT]: {
                    ...PRIMARY_CONTACT_CENTER_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                },
                [LinkStateType.PRESSED]: {
                    ...PRIMARY_CONTACT_CENTER_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_contact_center_accent_pressed_primary_font_50,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_contact_center_accent_pressed_primary_icon_50,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...PRIMARY_CONTACT_CENTER_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...PRIMARY_CONTACT_CENTER_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...PRIMARY_CONTACT_CENTER_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_contact_center_accent_default_primary_font_50,
                        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
                    },
                    icon: {
                        ...PRIMARY_CONTACT_CENTER_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_contact_center_accent_default_primary_icon_50,
                    },
                    labelIconContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).labelIconContainer,
                        text_decoration: 'none',
                    },
                    childrenContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).childrenContainer,
                        text_decoration: 'none',
                    },
                },
            },
        },
        [LinkActionType.INLINE]: {
            [LinkVariantType.PRIMARY]: {
                [LinkStateType.DEFAULT]: { ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT) },
                [LinkStateType.PRESSED]: {
                    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_primary_pressed_font,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_primary_pressed_icon,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    labelIconContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).labelIconContainer,
                        text_decoration: 'none',
                    },
                    childrenContainer: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).childrenContainer,
                        text_decoration: 'none',
                    },
                    container: {
                        ...LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
                    },
                },
            },
            [LinkVariantType.SECONDARY]: {
                [LinkStateType.DEFAULT]: { ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT) },
                [LinkStateType.PRESSED]: {
                    ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_secondary_pressed_font,
                    },
                    icon: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_secondary_pressed_icon,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_default_secondary_font_200,
                        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
                    },
                    icon: {
                        ...SECONDARY_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_default_secondary_font_100,
                    },
                },
            },
            [LinkVariantType.MAIN_SECTION_HEADERS]: {
                [LinkStateType.DEFAULT]: { ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT) },
                [LinkStateType.PRESSED]: {
                    ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_pressed_secondary_font_250,
                    },
                    icon: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_pressed_secondary_icon_250,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        font_variant: TextVariantType.FONT_PARAGRAPH_400,
                        color: FOUNDATIONS.color_exception_accent_default_secondary_font_50,
                    },
                    icon: {
                        ...MAIN_SECTION_HEADERS_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                    },
                },
            },
            [LinkVariantType.SECONDARY_ON_SURFACE]: {
                [LinkStateType.DEFAULT]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                },
                [LinkStateType.PRESSED]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_comp_navigation_link_techonly_pressed_font,
                    },
                    icon: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_navigation_link_techonly_pressed_icon,
                    },
                },
                [LinkStateType.VISITED]: {},
                [LinkStateType.DISABLED]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    icon: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                [LinkStateType.HOVER]: {
                    ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT),
                    container: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                        color: FOUNDATIONS.color_exception_accent_default_secondary_font_50,
                        font_variant: TextVariantType.LINK_FONT_PARAGRAPH_400,
                    },
                    icon: {
                        ...SECONDARY_ON_SURFACE_LINK_COMMON_TOKENS(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=styles.js.map